<template>
  <div class="psd-container">
    <img :src="src" v-if="normal">
    <div class="fail" v-else>此链接已失效</div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";

.psd-container {
  img {
    width: 100%;
    height: auto;
    -webkit-touch-callout: default;
    pointer-events: auto;
  }

  .fail {
    position: absolute;
    top: 40%;
    width: 100%;
    font-size: $ucar_font_h4;
    color: $ucar_alert_color;
    text-align: center;
  }
}
</style>

<script>
import { decodeCompanyId } from '../../utils/transform'

export default {
  data () {
    return {
      src: '',
      normal: true
    }
  },
  mounted () {
    if (!this.$route.query.q) {
      this.normal = false
      return
    }
    // 新接口
    this.$gw('/resource/dw/ucar/recruit/getCompanyPoster', {
      companyId: decodeCompanyId(this.$route.query.q)
    }).then(
      res => {
        this.src = res.picUrl
      },
      () => {
        this.normal = false
      }
    )
  }
}
</script>
